import React, { useState, useEffect } from 'react'
import UserSelector from '../../UserSelector'
import TextField from '../../ui/TextField'
import { Modal } from 'react-bootstrap'

const AssignStaffModal = ({ activeEventBooking, onCancel, handleStaffAssignedToBooking, apiKey }) => {
  const [ staffMemberId, setStaffMemberId ] = useState(null)
  const [ staffMemberRole, setStaffMemberRole ] = useState('Staff')

  useEffect(() => {
    if(activeEventBooking) {
      setStaffMemberRole(activeEventBooking.attributes.defaultStaffTitle || 'Staff')
    }
  }, [activeEventBooking])

  function handleCancel() {
    setStaffMemberId(null)
    setStaffMemberRole('Staff')
    onCancel()
  }

  async function handleSubmit(e) {
    e.preventDefault()
    await handleStaffAssignedToBooking({ staffMemberId, staffMemberRole, bookingId: activeEventBooking.attributes.eventId })
    setStaffMemberId(null)
    setStaffMemberRole('Staff')
  }

  return (
    <Modal show={!!activeEventBooking} onHide={handleCancel} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Booking Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { activeEventBooking && (
          <>
            <div className="card mb-3">
              <div className="card-body">
                <h4>{ activeEventBooking.attributes.title }</h4>
                <h5>{ activeEventBooking.attributes.formattedDatetimeRange }</h5>
                <div>
                  { activeEventBooking.attributes.brandName  }
                </div>
                { activeEventBooking.attributes.staffMemberNames && (
                  <div>
                    <strong>Currently Assigned Staff:</strong> { activeEventBooking.attributes.staffMemberNames  }
                  </div>
                )}
                <a href={`/events/${activeEventBooking.attributes.eventId}`} className="btn btn-secondary mt-3" target="_blank" rel="noopener noreferrer">
                  View Booking
                </a>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="card mb-3">
                <div className="card-body">
                  <h5>Assign Staff Member</h5>
                  <UserSelector
                    role="staff"
                    clearable={true}
                    apiKey={apiKey}
                    checkAvailabilityForEvent={activeEventBooking?.attributes?.eventId}
                    onChange={({value, label, attributes}) => setStaffMemberId(value)}
                  />
                  <TextField
                    label="Role"
                    name="role"
                    value={staffMemberRole}
                    onChange={setStaffMemberRole}
                    className="mt-3"
                    placeholder="Enter role (e.g., Staff, Manager)"
                  />
                  <input type="submit" value="Assign Staff" className="btn btn-primary mt-3" />
                </div>
              </div>
            </form>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleCancel}>Close</button>
      </Modal.Footer>
    </Modal>
  )
}

export default AssignStaffModal
